import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Box, Divider, useTheme } from "@mui/material";
import { useQuery } from "@tanstack/react-query";
import { TypoTitle } from "../About";
import Icon from "@/components/icon/Icon";
import { Edit, Sizes } from "@/components/icon/IconList";
import CheckLoginDialog from "@/components/modal/CheckLoginDialog";
import { usePagination } from "@/hooks/usePaginationNew";
import useSearchParams from "@/hooks/useSearchParams";
import { useAuthStore } from "@/lib/auth/AuthStore";
import { mixpanelEvent } from "@/lib/mixpanels/mixpanel";
import useWindowDimensions from "@/lib/web-ui/useWindowDimensions";
import { BRAND_QNA_DETAIL_PAGE, BRAND_QNA_NEW_PAGE } from "@/settings/constant";
import { Button, Pagination } from "@bookips/solvook-ui-library";
import dayjs from "dayjs";
import Link from "next/link";
import { useRouter } from "next/router";
import { useState } from "react";
import { getBrandQnA } from "src/api/brand";
import { useBrandStore } from "../BrandProvider";
import EmptyArea from "../EpmtyArea";
import BoardListItem from "../Notices/BoardListItem";
import { useBrandSnackbar } from "../SnackbarProvider";
const LIMIT = 10;
const BrandQnA = ()=>{
    const theme = useTheme();
    const router = useRouter();
    const [loginDialogOpen, setLoginDialogOpen] = useState(false);
    const { isLoggedIn , user  } = useAuthStore();
    const name = useBrandStore((state)=>state.brand.name);
    const nickname = useBrandStore((state)=>state.brand.nickname);
    const brandTitle = useBrandStore((state)=>state.brand.title);
    const searchParams = useSearchParams();
    const isBrandUser = user.displayName === nickname;
    const { isMobile  } = useWindowDimensions();
    const { data: qnaListItems  } = useQuery([
        "brandQnA",
        name,
        searchParams.toString()
    ], ()=>getBrandQnA({
            name,
            offset,
            limit: LIMIT
        }), {
        select: (data)=>{
            return {
                ...data.pagination,
                data: data.data.map((item)=>({
                        ...item,
                        createdAt: "".concat(dayjs(item.createdAt).format("YYYY.MM.DD HH:mm"))
                    }))
            };
        }
    });
    var _qnaListItems_total;
    const { offset , currentPage , onChangePage , totalPage  } = usePagination({
        limit: 10,
        totalCount: (_qnaListItems_total = qnaListItems === null || qnaListItems === void 0 ? void 0 : qnaListItems.total) !== null && _qnaListItems_total !== void 0 ? _qnaListItems_total : 0,
        isUseAsPath: true
    });
    const { showSnackbar  } = useBrandSnackbar();
    const handleAskQuestionClick = ()=>{
        if (!isLoggedIn) {
            setLoginDialogOpen(true);
            return;
        } else {
            router.push(BRAND_QNA_NEW_PAGE(name));
        }
    };
    return /*#__PURE__*/ _jsxs(Box, {
        sx: {
            margin: "0 20px",
            display: "flex",
            flexDirection: "column",
            gap: "32px"
        },
        children: [
            /*#__PURE__*/ _jsxs(TypoTitle, {
                sx: {
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between"
                },
                children: [
                    "Q&A 게시판",
                    /*#__PURE__*/ _jsx(Button, {
                        variant: "filledSecondary",
                        size: isMobile ? "small" : "medium",
                        onClick: ()=>{
                            handleAskQuestionClick();
                            //mx-244
                            mixpanelEvent("Create Post Button Click", {
                                Position: "Brand QnA List",
                                "Brand Name": brandTitle,
                                "Button Name": "질문하기"
                            });
                        },
                        sx: {
                            width: "fit-content",
                            display: "flex",
                            alignItems: "center",
                            gap: "4px"
                        },
                        label: /*#__PURE__*/ _jsxs(_Fragment, {
                            children: [
                                /*#__PURE__*/ _jsx(Icon, {
                                    icon: Edit,
                                    color: theme.palette.primary.main,
                                    size: Sizes.smallHalf
                                }),
                                "질문하기"
                            ]
                        })
                    })
                ]
            }),
            (qnaListItems === null || qnaListItems === void 0 ? void 0 : qnaListItems.data.length) === 0 ? /*#__PURE__*/ _jsx(EmptyArea, {
                text: "등록된 질문이 없어요."
            }) : /*#__PURE__*/ _jsxs(Box, {
                component: "ul",
                children: [
                    qnaListItems === null || qnaListItems === void 0 ? void 0 : qnaListItems.data.map((item)=>{
                        return item.isPrivate && !(user.displayName === nickname) && !item.isOwn ? /*#__PURE__*/ _jsxs(Box, {
                            onClick: ()=>showSnackbar({
                                    text: "비공개 질문글이에요.",
                                    icon: "warning"
                                }),
                            children: [
                                /*#__PURE__*/ _jsx(BoardListItem, {
                                    ...item,
                                    isBrandUser: isBrandUser
                                }),
                                /*#__PURE__*/ _jsx(Divider, {
                                    sx: {
                                        margin: "32px 0"
                                    }
                                })
                            ]
                        }, item.postId) : /*#__PURE__*/ _jsxs(Link, {
                            href: BRAND_QNA_DETAIL_PAGE(name, item.postId),
                            children: [
                                /*#__PURE__*/ _jsx(BoardListItem, {
                                    ...item,
                                    isBrandUser: isBrandUser
                                }),
                                /*#__PURE__*/ _jsx(Divider, {
                                    sx: {
                                        margin: "32px 0"
                                    }
                                })
                            ]
                        }, item.postId);
                    }),
                    /*#__PURE__*/ _jsx(Pagination, {
                        page: currentPage,
                        onChange: (event, page)=>onChangePage(page),
                        count: totalPage,
                        size: "medium",
                        sx: {
                            "& ul": {
                                justifyContent: "center"
                            }
                        }
                    })
                ]
            }),
            /*#__PURE__*/ _jsx(CheckLoginDialog, {
                open: loginDialogOpen,
                onClose: ()=>setLoginDialogOpen(false)
            })
        ]
    });
};
export default BrandQnA;
